import '@babel/polyfill';
import 'focus-visible';
import Vue from 'vue';
import UuidApp from './UuidApp.vue';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

document.addEventListener('DOMContentLoaded', () => {
    let root = document.querySelector('.js-vue');
    if (root) {
        new Vue({
            el: root,
            components: {
                'uuid-app': UuidApp,
            },
        });
    }
});
